import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  FormControl,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import swal from "sweetalert";
import ScrollToTopBtn from "../common/ScrollToTop";
import * as gkApi from "../../api/gkApi";
import { withRouter } from "../common/WithRouter";

class ImportList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      years: [],
      year: "",
      quarter: 1,
      page: 0,
      rowsPerPage: 50,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    try {
      const years = await gkApi.getYears();
      years.sort((a, b) => b - a);
      if (years) {
        const year = years[0];
        this.setState(
          {
            years: years,
            year: year,
          },
          () => this.getImportList()
        );
      }
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getImportList = async () => {
    const { year, quarter } = this.state;
    const list = await gkApi.getImportListCompanies(year, quarter);
    if (list) {
      list.sort((a, b) => a.companyName.localeCompare(b.companyName));
      this.setState({ list });
    } else {
      this.setState({ list: [] });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChange = async (e) => {
    await this.setState({ [e.target.name]: e.target.value });
    this.getImportList();
  };

  handleDelete = async (companyId) => {
    swal({
      title: "Slette avregning?",
      text: "",
      icon: "warning",
      dangerMode: true,
      buttons: ["Avbryt", "OK"],
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await gkApi.deleteimportdata(
            companyId,
            this.state.year,
            this.state.quarter
          );
          if (response.ok) {
            this.getImportList();
            swal("Data er slettet!", {
              icon: "success",
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  compareByDesc = (key) => {
    return function (a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  };

  compareByAsc = (key) => {
    return function (a, b) {
      if (a[key] < b[key]) return 1;
      if (a[key] > b[key]) return -1;
      return 0;
    };
  };

  sortBy = (key) => {
    let arrayCopy = [...this.state.list];
    if (this.state.sortDirection === "asc") {
      arrayCopy.sort(this.compareByAsc(key));
      this.setState({ list: arrayCopy, sortDirection: "desc" });
    } else {
      arrayCopy.sort(this.compareByDesc(key));
      this.setState({ list: arrayCopy, sortDirection: "asc" });
    }
  };

  render() {
    const quarters = [1, 2, 3, 4];

    const layoutStyle = {
      width: "80%",
      paddingTop: 80,
      margin: "auto",
    };

    const paperStyle = {
      width: "100%",
      padding: 20,
    };

    const tableWrapperStyle = {
      overflow: "auto",
    };

    const headStyle = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
      minWidth: 150,
    };

    const linkStyle = {
      textDecoration: "none",
      color: "#673ab7",
    };

    const emptyPaperStyle = {
      textAlign: "center",
      verticalAlign: "middle",
      lineHeight: "20px",
    };

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={layoutStyle}>
            <Paper style={paperStyle}>
              <React.Fragment>
                <CssBaseline />
                <Typography variant="h6" gutterBottom>
                  Liste over importerte data for gk-korrespondenter:
                </Typography>
                <Grid container>
                  <Typography variant="h6">Velg:</Typography>
                  <Grid item lg={4} style={{ marginLeft: 30 }}>
                    <FormControl variant="standard" fullWidth sx={{ minWidth: 120 }}>
                      <InputLabel>År</InputLabel>
                      <Select
                        name="year"
                        value={this.state.year || ""}
                        onChange={this.handleChange}
                      >
                        {this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={4} style={{ marginLeft: 30 }}>
                    <FormControl variant="standard" fullWidth sx={{ minWidth: 120 }}>
                      <InputLabel>Kvartal</InputLabel>
                      <Select
                        name="quarter"
                        value={this.state.quarter || ""}
                        onChange={this.handleChange}
                      >
                        {quarters.map((quarter, index) => (
                          <MenuItem key={index} value={quarter}>
                            {quarter}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={12}>
                    {this.state.list && this.state.list.length > 0 ? (
                      <Paper style={{ width: "100%", marginTop: 10 }}>
                        <div style={tableWrapperStyle}>
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell style={headStyle}></TableCell>
                                <TableCell
                                  style={{
                                    ...headStyle,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => this.sortBy("companyName")}
                                >
                                  Bedriftsnavn
                                </TableCell>
                                <TableCell style={headStyle}></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.list
                                .slice(
                                  this.state.page * this.state.rowsPerPage,
                                  this.state.page * this.state.rowsPerPage +
                                  this.state.rowsPerPage
                                )
                                .map((item, index) => (
                                  <TableRow hover key={index}>
                                    <TableCell>
                                      <Link
                                        to={`/gkimportdetail/${item.companyId}/${this.state.year}/${this.state.quarter}`}
                                        style={linkStyle}
                                      >
                                        <Button
                                          variant="outlined"
                                          size="medium"
                                          color="primary"
                                          style={{ margin: 1, whiteSpace: "nowrap" }}
                                        >
                                          <ArrowForwardIosIcon style={{ marginRight: 8 }} />
                                          Vis Mer
                                        </Button>
                                      </Link>
                                    </TableCell>
                                    <TableCell>{item.companyName}</TableCell>
                                    <TableCell>
                                      <Button
                                        style={{
                                          textDecoration: "none",
                                          color: "#B22222",
                                        }}
                                        onClick={() =>
                                          this.handleDelete(item.companyId)
                                        }
                                      >
                                        <DeleteForeverIcon />
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </div>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 50]}
                          component="div"
                          count={this.state.list.length}
                          rowsPerPage={this.state.rowsPerPage}
                          page={this.state.page}
                          onPageChange={this.handleChangePage}
                          onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                      </Paper>
                    ) : (
                      <Paper style={emptyPaperStyle}>Ingen treff</Paper>
                    )}
                  </Grid>
                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default withRouter(ImportList);
